import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-to-filter",
  "use": "various-to-filter-usage",
  "viewBox": "0 0 29 83",
  "content": "<symbol viewBox=\"0 0 29 83\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-to-filter\"><g fill=\"#e3000f\" fill-rule=\"evenodd\"><path d=\"M15.5 59v24h-2V59h-6l7-14 7 14h-6z\" fill-rule=\"nonzero\" /><path d=\"M0 0h14v14H0V0zm15 0h14v14H15V0zM0 15h14v14H0V15zm15 0h14v14H15V15zM0 30h14v14H0V30zm15 0h14v14H15V30z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol